var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('entryFile'):_vm._e(),_c('a',{staticStyle:{"position":"relative","display":"none","height":"38px"},attrs:{"href":"https://xyt.xcc.cn/getpcInfo?sn=1796532107770535936&language=CN&certType=8&url=www.xibuzhilian.com","target":"_blank","rel":"nofollow"}},[_vm._v("安全证书")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }